import { render, staticRenderFns } from "./MultImportPictureModel.vue?vue&type=template&id=4d5386f8&scoped=true&"
import script from "./MultImportPictureModel.vue?vue&type=script&lang=js&"
export * from "./MultImportPictureModel.vue?vue&type=script&lang=js&"
import style0 from "./MultImportPictureModel.vue?vue&type=style&index=0&id=4d5386f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5386f8",
  null
  
)

export default component.exports